<script setup>
/**
 * The switch between two sides of one reading: "Your reading" | "Its lesson"
 * (2026-10-25, community-lesson DESIGN.md L3; SP-W2: the first option is
 * always the seeker's own reading and the default). A paper pill with the
 * chosen side raised in white, as in the L3/L4/L6 frames.
 */
const props = defineProps({
  modelValue: { type: String, default: 'mine' },
  // [{ value, label }]
  options: { type: Array, default: () => [{ value: 'mine', label: 'Your reading' }, { value: 'public', label: 'Its lesson' }] },
  label: { type: String, default: 'Which version' },
})
const emit = defineEmits(['update:modelValue'])
function pick(v) { if (v !== props.modelValue) emit('update:modelValue', v) }
</script>

<template>
  <div class="vs" role="group" :aria-label="label" data-testid="share-switch">
    <button v-for="o in options" :key="o.value" type="button" class="vs-opt"
            :class="{ on: o.value === modelValue }" :aria-pressed="o.value === modelValue ? 'true' : 'false'"
            :data-testid="`switch-${o.value}`" @click="pick(o.value)">{{ o.label }}</button>
  </div>
</template>

<style scoped>
.vs { display: inline-flex; gap: 0; padding: 4px; border-radius: 999px; background: #efe5d2; min-width: 0; max-width: 100%; }
.vs-opt {
  min-height: 44px; padding: 8px 18px; border: 0; border-radius: 999px; background: transparent;
  font: 600 13.5px/1.2 Inter, system-ui, sans-serif; color: #6b5a82; cursor: pointer;
  transition: background .18s ease, color .18s ease; min-width: 0; overflow-wrap: anywhere;
}
.vs-opt.on { background: #fff; color: #2a1845; box-shadow: 0 2px 8px -3px rgba(42, 24, 69, .35); }
.vs-opt:not(.on):hover { color: #2a1845; }
.vs-opt:focus-visible { outline: 2px solid #7b4bb0; outline-offset: 2px; }
@media (max-width: 359px) { .vs-opt { padding: 8px 12px; } }
</style>
